import Api from '@/services/Api'
// import { log } from 'util';

export default {
  index (query) {
    return Api().get('task', {
      params: query
    })
  },
  // Koliko taskova ceka prijavljenog korisnika - brojcic uz ikonu korisnika.
  // Vraca {broj, poFirmama, zadnji}. Ne filtrira se po firmi: brojcic stoji uz
  // korisnika, a ne uz firmu, pa mora obuhvatiti i taskove iz firmi u kojima
  // korisnik trenutno nije otvoren.
  taskceka (query) {
    return Api().get(`taskceka`, {
      params: query
    })
  },
  // Taskovi koje korisnik treba OBAVITI. "index" vraca one koje je on ZADAO -
  // to je druga stvar i izvrsitelj svoj posao tamo ne vidi.
  taskmoji (query) {
    return Api().get(`taskmoji`, {
      params: query
    })
  },
  // "Obavljeno". Vraca novi broj taskova koji cekaju, pa brojcic ne mora
  // ponovno pitati. Zaseban od "put" jer onaj trazi cijeli task.
  taskzatvori (taskid, podaci) {
    return Api().put(`taskzatvori/${taskid}`, podaci)
  },
  // Obavijest o obavljenom zadatku (npr. direktoru, da to uvrsti u racun).
  // Salje se nakon spremanja: ako posta zakaze, zadatak je vec zapisan.
  taskobavijest (taskid, podaci) {
    return Api().post(`taskobavijest/${taskid}`, podaci)
  },
  tasktoday (query) {
    return Api().get(`tasktoday`, {
      params: query
    })
  },
  taskweek (query) {
    return Api().get(`taskweek`, {
      params: query
    })
  },
  taskalarmopen (query) {
    return Api().get(`taskalarmopen`, {
      params: query
    })
  },
  tasklast50 (query) {
    return Api().get(`tasklast50`, {
      params: query
    })
  },
  taskana (query) {
    return Api().get(`taskana`, {
      params: query
    })
  },
  taskemployee (employeeid) {
    return Api().get(`taskemployee/${employeeid}`)
  },
  show (taskid) {
    return Api().get(`task/${taskid}`)
  },
  post (newtask) {
    return Api().post('task', newtask)
  },
  put (task) {
    return Api().put(`task/${task.id}`, task)
  },
  delete (taskid) {
    return Api().delete(`task/${taskid}`)
  }
}
